import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      queue_number: 'getPosSelectedQueueNumber',
      queues: 'getPosQueues',
      posSettings: 'getPosSetting',
      getLatestQueueNumber: 'getLatestQueueNumber',
      getUsedQueueNumbers: 'getUsedQueueNumbers',
    }),
    getTextTitle() {
      return this.$t('apps.pos.message.queuebutton', {
        queue_number: this.queue_number == null ? 1 : this.queue_number,
        total_number: this.queues.length,
      })
    },
    use_dining () {
      return this.posSettings.dining.is_active
    },
  },

  watch: {
    loaded() {
      if (this.loaded === true && this.queues.length === 0) {
        this.addPosNextQueue()
      }
    },
  },

  created() {
    if (this.queue_number) {
      this.setPosSelectedQueue(this.queue_number)
    }
  },

  methods: {
    ...mapActions({
      setPosSelectedQueue: 'setPosSelectedQueue',
      setPosSection: 'setPosSection',
      setPosSelectedDiningName: 'setPosSelectedDiningName',
      setDiningNameForQueueAndTable: 'setDiningNameForQueueAndTable',
      addPosNextQueue: 'addPosNextQueue',
    }),
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/queueButton.js